module.exports = __webpack_public_path__ + "img/dosificacion_9.41025ed7.png";